import React from 'react';

import 'react-select/dist/react-select.css';
import POPUP from "../../../eappcomponents/commons/popup";
import * as commonApi from "../../../api/common-api";
import axios from 'axios';
import ImagePopup from "../../../eappcomponents/commons/ImagePopup";
import ReplyComment from "./ReplyComment";
import CommentBox from "./CommentBox";

class CommentItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ref: undefined,
            showReply: false,
            showPU: false
        };
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {}

    handleDeleted = (event) => {
        let url = '/code/api_experiences.php?api=delExperientialComments&id_comment=' + this.props.comment.id_comment;
        axios.get(url)
            .then(response => {
                if (response.data.status == 1) {
                    let newComment = Object.assign(this.props.comment, {});
                    this.props.onChange(newComment, "delete");
                }
                return response;
            });
    }

    getInput = (ref) => {
        this.setState({ref: ref});
    }

    handleReply = () => {
        this.setState({showReply: true});
    }

    handleLike = () => {
        var url = '/code/api_experiences.php?api=likeExperientialComments&id_comment=' + this.props.comment.id_comment;
        axios.get(url)
            .then(response => {
                var rst = response.data
                if (rst.status == 1) {
                    this.props.onChange(rst.data);
                }
                return response;
            });
    }

    onClose = () => {
        this.setState({showPU: false});
    }

    render() {
        let avatar = '/static/img/appimg/common-noavatar-sm.jpg';
        let comment = this.props.comment
        let user = this.props.user
        let c_user = comment.user
        let name = c_user.name_account + " " + c_user.last_name_account
        if (c_user.image_avatar_account > 0) {
            avatar = c_user.link_thumb_file;
        }

        let file_div = []
        let files = comment.files
        if (files !== undefined) {
            for (var item of comment.files) {
                file_div.push(
                    <div key={"files-" + item.id_file} className="comment_img">
                        <a href={item.link_file} target="_blank">{item.name_file}</a>
                    </div>
                )
            }
        }

        return (
            <div>
                <div className="comment_item">
                    <div className="comment_top_box">
                        <div className="comment_w1">
                            <img className="img_circle_s" src={avatar}/>
                        </div>
                        <div className="comment_w2">
                            <p className="comment_content">
                                <span className="user">{name} {comment.complete_joined_comment}</span>
                            </p>
                            {comment.content_comment}
                            {file_div}

                            {parseInt(user.id_account) === parseInt(comment.id_account_comment) && comment.complete_joined_comment === null ?
                                <span onClick={this.handleDeleted.bind(this)} className="glyphicon glyphicon-remove" aria-hidden="true"></span>
                            :""}
                            <div className="comment_bot_box">
                                <div className="like_comment">
                                    <a onClick={this.handleLike.bind(this)}>{comment.liked == 1 ? "Liked" : "Like"}&nbsp;({comment.likes.length})</a>
                                    <a className={this.props.isReply? "hide-el" : "mgl-10"} onClick={this.handleReply.bind(this)}>Reply&nbsp;({comment.replies})</a>
                                </div>
                                <span className="time_comment">{comment.time_comment}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showReply == true ?
                        (
                        <ReplyComment
                            getInput={this.getInput.bind(this)}
                            showReply={this.state.showReply}
                            user={this.props.user}
                            comment={comment}
                            joined={this.props.joined}
                            enable_ask={1}
                        />
                    )
                    : ""}
            </div>
        );
    }
}

export default CommentItem;


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/experiential/CommentItem.js
 **/